<template>
  <div class="bg_tab" style="overflow: hidden;">
    <!-- 标题 -->
    <div class="title">
      Tik游戏盒
      <span @click="goMessage">
        <van-icon name="chat-o" dot v-if="checkRedDot" />
        <!-- <van-icon name="chat-o" dot v-if="true" /> -->
        <van-icon name="chat-o" v-else />
      </span>
    </div>
    <!-- 热门游戏 -->
    <div class="title_heat">
      <div class="heat_img"></div>  
      <div class="heat_text">{{ play }}</div>
    </div>
    <!-- 轮播图 -->
    <div>
      <!-- 热门游戏 -->
      <van-swipe
        class="my-swipe"
        :autoplay="0"
        indicator-color="white"
        v-if="now"
      >
        <van-swipe-item v-for="item in top" :key="item.gameUrl">
          <div @click="getId(item.id, item.gameUrl)">
            <a :href="item.gameUrl">
            <img
              style="width:100%;"
              :src="'https://app.tikgamebox.com/uploads/' + item.banner"
            />
            <!-- <img style="width:100%;height:100%" :src="'https://app.tikgamebox.com/uploads/' + item.banner"
              @click="getId(item.id)" /> -->
            <div></div>
          </a>
          </div>
          
        </van-swipe-item>
      </van-swipe>
      <!-- 当前游戏 -->
      <div class="my-swipesa">
        <a :href="gameUrl">
          <img
            style="width:100%;"
            :src="'https://app.tikgamebox.com/uploads/' + game_current"
            v-if="nows"
          />
          <!-- <div class="my-swipes"
          :style="{ backgroundImage: 'url(https://app.tikgamebox.com/uploads/' + game_current + ')', }" v-if="nows">
        </div> -->
        </a>
      </div>
      <!-- 旧版本 -->
      <div class="my-swipes" style="display: flex;" v-if="nowa">
        <a :href="gameUrl_last" style="width:50%;text-align: left;">
          <img
            style="width:85%;"
            :src="'https://app.tikgamebox.com/uploads/' + game_last"
          />
          <!-- <div class="current"
          :style="{ backgroundImage: 'url(https://app.tikgamebox.com/uploads/' + game_last + ')', }"></div> -->
        </a>
        <!-- 新版本 -->
        <a :href="gameUrl" style="width:50%;text-align: right;">
          <img
            style="width:85%;"
            :src="'https://app.tikgamebox.com/uploads/' + game_current"
          />
          <!-- <div class="current"
          :style="{ backgroundImage: 'url(https://app.tikgamebox.com/uploads/' + game_current + ')', }"></div> -->
        </a>
      </div>
    </div>
    <!-- 最近在玩 -->
    <div class="title_heat">
      <div class="heat_img"></div>
      <div class="heat_text">最近在玩</div>
    </div>
    <div class="play">
      <!-- v-for="(item) in dat.slice(0, 4)" -->
      <div
        v-for="item in dat.slice(0, 4)"
        :key="item.id"
        class="bg_play"
        :style="{ backgroundImage: 'url(' + item.urls + ')' }"
        @click="getId(item.id, item.gameUrl)"
      >
        <!-- <a :href="item.gameUrl"> -->
        <div style="height:100%">
          <div
            class="play_img"
            :style="{
              backgroundImage:
                'url(https://app.tikgamebox.com/uploads/' + item.icon + ')',
            }"
          ></div>
          <div class="play_title">{{ item.name }}</div>
        </div>
        <!-- </a> -->
      </div>
    </div>
    <!-- 最近流行 -->
    <div class="title_heat">
      <div class="heat_img"></div>
      <div class="heat_text">最近流行</div>
    </div>
    <div class="prevalent">
      <div
        v-for="item in pop"
        :key="item.id"
        class="prevalent_box"
        @click="getId(item.id, item.gameUrl)"
      >
        <!-- <a :href="item.gameUrl"> -->
        <div style="height:100%">
          <div
            class="prevalent_img"
            :style="{
              backgroundImage:
                'url(https://app.tikgamebox.com/uploads/' + item.icon + ')',
            }"
          ></div>
          <div class="prevalen_title">{{ item.name }}</div>
          <div class="prevalen_number">{{ item.desc }}万人在玩</div>
        </div>
        <!-- </a> -->
      </div>
    </div>
    <!-- 游戏库 -->
    <div class="title_heat">
      <div class="heat_img"></div>
      <div class="heat_text">游戏库</div>
    </div>
    <van-tabs v-model="mod">
      <van-tab title="全部">
        <div class="prevalents" :style="{ height: ht }" style="height:300px;">
          <div
            v-for="item in all"
            :key="item.id"
            class="prevalent_boxs"
            @click="getId(item.id, item.gameUrl)"
            :style="{ visibility: item.isShow == true ? 'hidden' : 'visible' }"
          >
            <!-- <a :href="item.gameUrl"> -->
            <div style="height:100%;">
              <div
                class="prevalent_img"
                :style="{
                  backgroundImage:
                    'url(https://app.tikgamebox.com/uploads/' + item.icon + ')',
                }"
                v-if="item.isShow != true"
              ></div>
              <div class="prevalen_title">{{ item.name }}</div>
              <div class="prevalen_number">{{ item.desc }}万人在玩</div>
            </div>
            <!-- </a> -->
          </div>
        </div>
      </van-tab>
      <van-tab title="休闲">
        <div class="prevalents" :style="{ height: ht }">
          <div
            v-for="item in arder"
            :key="item.id"
            class="prevalent_boxs"
            @click="getId(item.id, item.gameUrl)"
            :style="{ visibility: item.isShow == true ? 'hidden' : 'visible' }"
          >
            <!-- <a :href="item.gameUrl"> -->
            <div style="height:100%">
              <div
                class="prevalent_img"
                :style="{
                  backgroundImage:
                    'url(https://app.tikgamebox.com/uploads/' + item.icon + ')',
                }"
                v-if="item.isShow != true"
              ></div>
              <div class="prevalen_title">{{ item.name }}</div>
              <div class="prevalen_number">{{ item.desc }}万人在玩</div>
            </div>
            <!-- </a> -->
          </div>
        </div>
      </van-tab>
      <van-tab title="养成">
        <div class="prevalents" :style="{ height: ht }">
          <div
            v-for="item in cultivate"
            :key="item.id"
            class="prevalent_boxs"
            @click="getId(item.id, item.gameUrl)"
            :style="{ visibility: item.isShow == true ? 'hidden' : 'visible' }"
          >
            <!-- <a :href="item.gameUrl"> -->
            <div style="height:100%">
              <div
                class="prevalent_img"
                :style="{
                  backgroundImage:
                    'url(https://app.tikgamebox.com/uploads/' + item.icon + ')',
                }"
                v-if="item.isShow != true"
              ></div>
              <div class="prevalen_title">{{ item.name }}</div>
              <div class="prevalen_number">{{ item.desc }}万人在玩</div>
            </div>
            <!-- </a> -->
          </div>
        </div>
      </van-tab>
      <van-tab title="经营">
        <div class="prevalents" :style="{ height: ht }">
          <div
            v-for="item in manage"
            :key="item.id"
            class="prevalent_boxs"
            @click="getId(item.id, item.gameUrl)"
            :style="{ visibility: item.isShow == true ? 'hidden' : 'visible' }"
          >
            <!-- <a :href="item.gameUrl"> -->
            <div style="height:100%">
              <div
                class="prevalent_img"
                :style="{
                  backgroundImage:
                    'url(https://app.tikgamebox.com/uploads/' + item.icon + ')',
                }"
                v-if="item.isShow != true"
              ></div>
              <div class="prevalen_title">{{ item.name }}</div>
              <div class="prevalen_number">{{ item.desc }}万人在玩</div>
            </div>
            <!-- </a> -->
          </div>
        </div>
      </van-tab>
      <van-tab title="动作">
        <div class="prevalents" :style="{ height: ht }">
          <div
            v-for="item in movement"
            class="prevalent_boxs"
            :key="item.id"
            @click="getId(item.id, item.gameUrl)"
            :style="{ visibility: item.isShow == true ? 'hidden' : 'visible' }"
          >
            <!-- <a :href="item.gameUrl"> -->
            <div style="height:100%">
              <div
                class="prevalent_img"
                :style="{
                  backgroundImage:
                    'url(https://app.tikgamebox.com/uploads/' + item.icon + ')',
                }"
                v-if="item.isShow != true"
              ></div>
              <div class="prevalen_title">{{ item.name }}</div>
              <div class="prevalen_number">{{ item.desc }}万人在玩</div>
            </div>
            <!-- </a> -->
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { resolve } from "path";
import { Stream } from "stream";
import { runInNewContext } from "vm";
import { ref } from "vue";
import { getUrlParam } from "@/utils/index";
export default {
  data() {
    return {
      imgurl: [
        { urls: require("../assets/imgs/bg_play1.png") },
        { urls: require("../assets/imgs/bg_play2.png") },
        { urls: require("../assets/imgs/bg_play3.png") },
        { urls: require("../assets/imgs/bg_play4.png") },
      ],
      // prevalent: [
      //   { title: '光影对决', number: '124', urls: require("../assets/imgs/bg_play1.png") },
      //   { title: '光影对决', number: '124', urls: require("../assets/imgs/bg_play1.png") },
      //   { title: '光影对决', number: '124', urls: require("../assets/imgs/bg_play1.png") },
      //   { title: '光影对决', number: '124', urls: require("../assets/imgs/bg_play1.png") },
      //   { title: '光影对决', number: '124', urls: require("../assets/imgs/bg_play1.png") },
      //   { title: '光影对决', number: '124', urls: require("../assets/imgs/bg_play1.png") },
      //   { title: '光影对决', number: '124', urls: require("../assets/imgs/bg_play1.png") },
      //   { title: '光影对决', number: '124', urls: require("../assets/imgs/bg_play1.png") },
      //   { title: '光影对决', number: '124', urls: require("../assets/imgs/bg_play1.png") },
      // ],
      all: [], //游戏库全部
      pop: [], //最近流行
      top: [], //轮播图
      dat: [], //最近在玩
      mod: 0, //切换选择
      arder: [], //休闲
      cultivate: [], //养成
      manage: [], //经营
      movement: [], //动作
      play: "热门游戏", //游戏模式
      now: true, //热门游戏
      nows: false, //当前游戏
      nowa: false, //旧版本
      // ht: 'calc(100vh - 600px)',
      ht: "",
      gameUrl: "", //新游戏
      game_current: "",
      gameUrl_last: "", //旧游戏
      game_last: "",
      game_id: "", //游戏id
      land: "", //判断横竖屏
      windowWidth: document.documentElement.clientWidth, //获取屏幕宽度
      const: {
        did: "",
        language: "",
        screen: "",
        network: "",
        zone: "",
        time: "",
        channel_id: "",
      },
    };
  },
  watch: {
    windowWidth(val) {
      this.wid();
      this.getMenuList();
      this.getPagams("休闲");
      this.getPagams("养成");
      this.getPagams("经营");
      this.getPagams("动作");

      // let that = this;
      // console.log("实时屏幕宽度：", val, that.windowHeight);
    },
    mod(newName, oldName) {
      if (newName == 1) {
        this.getPagams("休闲");
      } else if (newName == 2) {
        this.getPagams("养成");
      } else if (newName == 3) {
        this.getPagams("经营");
      } else if (newName == 4) {
        this.getPagams("动作");
      }
    },
  },
  created() {
    

    // //获取系统语言
    // let lan = navigator.systemLanguage || navigator.language;
    // switch (lan.toLowerCase()) {
    //   case "zh-tw":
    //     this.const.language = 'zh-tw';
    //     break;
    //   case "zh-hk":
    //     this.const.language = 'zh-hk';
    //     break;
    //   case "zh-cn":
    //     this.const.language = 'zh-cn';
    //     break;
    //   default:
    //     this.const.language = 'zh-en';
    //     break;
    // }
    //获取屏幕分辨率
    var width = window.screen.width;
    var height = window.screen.height;
    
    width = width.toString();
    height = height.toString();
    console.log(width,'宽度');
    console.log(height,'高度');
    this.const.screen = `${width},${height}`;
    // 获取网络状态
    // var state = navigator.connection.effectiveType;
    // this.const.network = state;
    //获取时区
    var zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    console.log(zone, "时区");

    this.const.zone = zone;

    function UrlSearch() {
      var name, value;
      var str = location.href; //取得整个地址栏
      var num = str.indexOf("?");
      str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

      var arr = str.split("&"); //各个参数放到数组里
      for (var i = 0; i < arr.length; i++) {
        num = arr[i].indexOf("=");
        if (num > 0) {
          name = arr[i].substring(0, num);
          value = arr[i].substr(num + 1);
          this[name] = value;
        }
      }
    }
    var Request = new UrlSearch(); //实例化
    // alert(Request.game_id)
    // alert(Request.land)
    this.game_id = Request.game_id || "";
    this.land = Request.land;
    if (Request.game_id) {
      window.localStorage.setItem("tik_gameid", Request.game_id);
    }

    //获取系统语言
    let lan = navigator.systemLanguage || navigator.language;
    switch (lan.toLowerCase()) {
      case "zh-tw":
        this.const.language = "zh-tw";
        break;
      case "zh-hk":
        this.const.language = "zh-hk";
        break;
      case "zh-cn":
        this.const.language = "zh-cn";
        break;
      default:
        this.const.language = "zh-en";
        break;
    }

    // if (window.innerHeight < window.innerWidth) {
    //   // document.documentElement.style.transform = 'rotate(-90deg)';
    //   // document.documentElement.style.transformOrigin = '50% 50%';
    //   // document.documentElement.style.transformOrigin = '44% 31%';
    //   // document.documentElement.style.width = '100vh';
    //   // document.documentElement.style.height = '100vw';
    //   // document.documentElement.style.overflowX = 'hidden';
    //   // document.documentElement.style.position = 'absolute';
    //   // document.documentElement.style.position = 'absolute';
    //   // document.documentElement.style.top = '-150%';
    //   // document.documentElement.style.left = '0';
    // } else {
    //   // document.documentElement.style.transform = 'rotate(0deg)';
    //   // document.documentElement.style.transform = '';
    //   // document.documentElement.style.transformOrigin = '';
    //   // document.documentElement.style.width = '';
    //   // document.documentElement.style.height = '';
    //   // document.documentElement.style.overflowX = '';
    //   // document.documentElement.style.position = '';
    //   // document.documentElement.style.top = '';
    //   // document.documentElement.style.left = '';
    // }
    // this.getMenuList();

    // this.getMenuLists();
    // var sHref = window.location.href;
    // // var args = sHref.split('?');

    // //  var arr = args[1].split('=')
    // var arr = sHref.split('=')
    // if (arr[1]) {
    //   this.now = false;
    //   this.play = '当前游戏';
    //   this.mate(arr[1]);
    // } else {
    //   this.now = true;
    //   this.play = '热门游戏'
    // }
    setTimeout(() => {
      var did = window.localStorage.getItem("did");
    var tik_did = window.localStorage.getItem("tik_did");
    if (tik_did) {
      window.localStorage.setItem("tik_did", tik_did);
      this.con();
    } else if ((did == null) & (tik_did == null)) {
      this.tik_id();
    } else {
      this.tik_id();
    }
    }, 0);
  },
  mounted() {
    const testtik_gameid = getUrlParam("game_id");
    // console.log(testtik_gameid, "testtik_gameid");
    // if (window.innerHeight < window.innerWidth) {
    //   // console.log('横屏的时候++++++++')
    //   // bg_tab.style.transform = 'rotate(-90deg)';
    //   // bg_tab.style.width = '100vh';
    //   // bg_tab.style.height = '100vw';
    //   var strs = this.dat.length == 0 ? 'calc(100vw - 455px)' : 'calc(100vw - 580px)';
    //   this.ht = strs;
    //   // bg_tab.style.border = '5px solid blue';

    // } else {
    //   var stra = this.dat.length == 0 ? 'calc(100vh - 455px)' : 'calc(100vh - 580px)';
    //   this.ht = stra;
    //   // console.log('竖屏的时候===================')
    //   // bg_tab.style.height = '100vh';
    //   // bg_tab.style.width = '100%';
    //   // bg_tab.style.transform = 'rotate(0deg)';
    //   // var stra = this.dat.length == 0 ? 'calc(100vh - 455px)' : 'calc(100vh - 580px)';
    //   // this.ht = stra;
    //   // bg_tab.style.height = '100vh';
    //   // bg_tab.style.width = '100vw';

    //   // bg_tab.style.border = '5px solid yellow';
    // }
    // if(this.game_id){
    //   window.localStorage.setItem("tik_gameid",this.game_id);
    // }

    // this.con();//获取设备参数

    this.getMenuList();
    // this.getMenuLists()
    var that = this;
    this.wid();
    window.onresize = () => {
      return (() => {
        window.fullHeight = document.documentElement.clientHeight;
        window.fullWidth = document.documentElement.clientWidth;
        that.windowHeight = window.fullHeight; //获取屏幕高度
        that.windowWidth = window.fullWidth; //获取屏幕宽度
      })();
    };
    //游戏库高度
    // var str = this.dat.length == 0 ? 'calc(100vh - 455px)' : 'calc(100vh - 580px)';
    // // var str = play.childNodes.length == 0 ? 'calc(100vh - 455px)' : 'calc(100vh - 580px)';
    // this.ht = str;
  },
  computed: {
    // 是否显示红点
    checkRedDot() {
      if(localStorage.getItem('tongzhi_info')==null||localStorage.getItem('tongzhi_info')==undefined||localStorage.getItem('tongzhi_info')==''){
        return true
      }
      const backContentList = JSON.parse(
        localStorage.getItem("backContentList")
      )||[];
      const tongzhi_info = JSON.parse(localStorage.getItem("tongzhi_info"))||[];
      
      const res1 = backContentList.find((item) => {
        if (item.isclick == false) {
          return true;
        }
      });
      const res2 = tongzhi_info.find((item) => {
        if (item.isclick == false) {
          return true;
        }
      });
      if (res1 || res2) {
        return true;
      } 
      return false
    },
  },
  methods: {
    goMessage() {
      this.$router.push("/message");
    },
    wid() {
      //游戏库高度
      // var str = this.dat.length == 0 ? 'calc(100vh - 455px)' : 'calc(100vh - 580px)';
      // this.ht = str;

      if (window.innerHeight < window.innerWidth) {
        var strs =
          this.dat.length == 0 ? "calc(100vw - 455px)" : "calc(100vw - 580px)";
        this.ht = strs;
        if (document.body.offsetWidth > 500) {
          var str =
            this.dat.length == 0
              ? "calc(100vw - 600px)"
              : "calc(100vw - 750px)";
          this.ht = str;
        }
      } else if (window.innerHeight > window.innerWidth) {
        var stra =
          this.dat.length == 0 ? "calc(100vh - 455px)" : "calc(100vh - 580px)";
        this.ht = stra;
        if (document.body.offsetWidth > 500) {
          var str =
            this.dat.length == 0
              ? "calc(100vh - 600px)"
              : "calc(100vh - 750px)";
          this.ht = str;
        }
      }
    },
    // 游戏库
    async getMenuList() {
      const { data: res } = await this.$http.get(
        "/gz/gamelist?land=" + this.land + "&time=" + Date.now()
      );
      var len = res.all.length;
      var num = parseInt(len % 4);
      if (num == 1 || len == 1) {
        this.all = res.all;
        this.all.push({ isShow: true });
        this.all.push({ isShow: true });
        this.all.push({ isShow: true });
        if (document.body.offsetWidth > 500) {
          this.all.push({ isShow: true });
          this.all.push({ isShow: true });
          this.all.push({ isShow: true });
          this.all.push({ isShow: true });
        }
      } else if (num == 2 || len == 2) {
        this.all = res.all;
        this.all.push({ isShow: true });
        this.all.push({ isShow: true });
        if (document.body.offsetWidth > 500) {
          this.all.push({ isShow: true });
          this.all.push({ isShow: true });
          this.all.push({ isShow: true });
          this.all.push({ isShow: true });
        }
      } else if (num == 3 || len == 3) {
        this.all = res.all;
        this.all.push({ isShow: true });
        if (document.body.offsetWidth > 500) {
          this.all.push({ isShow: true });
          this.all.push({ isShow: true });
          this.all.push({ isShow: true });
          this.all.push({ isShow: true });
        }
      } else if ((num == 0) & (document.body.offsetWidth > 500)) {
        this.all = res.all;
        this.all.push({ isShow: true });
        this.all.push({ isShow: true });
        this.all.push({ isShow: true });
        this.all.push({ isShow: true });
      } else {
        this.all = res.all;
      }

      // this.getMenuLists();
      this.pop = res.pop; //最近流行
      this.top = res.top; //轮播图
      this.getMenuLists();

      // var sHref = window.location.href;
      // var args = sHref.split('?');

      //  var arr = args[1].split('=')
      // console.log(sHref, '==================-----====')
      // var arr = sHref.split('=')
      // console.log(arr, '获取数据============')
      // var asd = arr[1].split('&');
      // console.log(asd, '-=-=--=-=-=-==--123456')

      // function UrlSearch() {
      //   var name, value;
      //   var str = location.href; //取得整个地址栏
      //   var num = str.indexOf("?")
      //   str = str.substr(num + 1); //取得所有参数   stringvar.substr(start [, length ]

      //   var arr = str.split("&"); //各个参数放到数组里
      //   for (var i = 0; i < arr.length; i++) {
      //     num = arr[i].indexOf("=");
      //     if (num > 0) {
      //       name = arr[i].substring(0, num);
      //       value = arr[i].substr(num + 1);
      //       this[name] = value;
      //     }
      //   }
      // }
      // var Request = new UrlSearch(); //实例化
      // alert(Request.game_id);
      // alert(Request.land);

      // if (arr[1]) {
      //   // this.now = false;
      //   // this.now = true;
      //   this.play = '当前游戏';
      //   this.mate(arr[1]);
      // } else {
      //   this.now = true;
      //   this.nows = false;
      //   this.play = '热门游戏'
      // }

      if (this.game_id) {
        // this.now = false;
        // this.now = true;
        this.play = "当前游戏";
        this.mate(this.game_id);
      } else {
        this.now = true;
        this.nows = false;
        this.play = "热门游戏";
      }

      //111
    },
    //游戏库匹配放到最近在玩
    async getMenuLists() {
      // var tik_did = window.localStorage.getItem("tik_did") || '';
      var tik_did = window.localStorage.getItem("tik_did") || "";

      const { data: res } = await this.$http.get(
        "/gz/rgame?did=" +
          tik_did +
          "&land=" +
          this.land +
          "&time=" +
          Date.now()
      );
      this.dat = [];
      res.map((item) => {
        this.all.map((items) => {
          if (item == items.id) {
            this.dat.push(items);
          }
        });
      });
      this.dat.slice(0, 4).forEach((value, index) => {
        value["urls"] = this.imgurl[index].urls;
      });

      //游戏库高度
      if (window.innerHeight < window.innerWidth) {
        // document.documentElement.style.transform = 'rotate(-90deg)';
        var strs =
          this.dat.length == 0 ? "calc(100vw - 455px)" : "calc(100vw - 580px)";
        this.ht = strs;
        if (document.body.offsetWidth > 500) {
          var str =
            this.dat.length == 0
              ? "calc(100vw - 600px)"
              : "calc(100vw - 750px)";
          this.ht = str;
        }
      } else if (window.innerHeight > window.innerWidth) {
        // document.documentElement.style.transform = 'rotate(0deg)';
        var stra =
          this.dat.length == 0 ? "calc(100vh - 455px)" : "calc(100vh - 580px)";
        this.ht = stra;
        if (document.body.offsetWidth > 500) {
          var str =
            this.dat.length == 0
              ? "calc(100vh - 600px)"
              : "calc(100vh - 750px)";
          this.ht = str;
        }
      }
    },
    //用户idF
    async getPagam(value) {
      // var did = window.localStorage.getItem("did") || '';
      // var tik_did = window.localStorage.getItem("tik_did") || '';
      var tik_did = window.localStorage.getItem("tik_did") || "";
      // if(did){
      //   window.localStorage.setItem("tik_did", did);
      // }else if(did&tik_did){
      //   this.tik_id()
      // }

      // alert(Request.game_id)
      // alert(Request.land)

      const tik_gameid =
        getUrlParam("game_id") ||
        window.localStorage.getItem("tik_gameid") ||
        "";
      if (tik_gameid && tik_gameid != "" && tik_gameid != undefined) {
        const { data: res } = await this.$http.get(
          "/gz/pgame?gid=" +
            value +
            "&channel_id=" +
            tik_gameid +
            "&did=" +
            tik_did +
            "&time=" +
            Date.now()
        );
      } else {
        const { data: res } = await this.$http.get(
          "/gz/pgame?gid=" + value + "&did=" + tik_did + "&time=" + Date.now()
        );
      }
      debugger;
      // window.localStorage.setItem("did", res.did);
    },
    //获取tik_did
    async tik_id() {
      // var did = window.localStorage.getItem("did") || '';
      // var tik_did = window.localStorage.getItem("tik_did") || '';
      // if(did){
      //   window.localStorage.setItem("tik_did", did);
      // }else if(did&tik_did){
      //   this.tik_id()
      // }

      const { data: res } = await this.$http.get(
        "/gz/getdid?time=" + Date.now()
      );
      window.localStorage.setItem("tik_did", res.did);

      this.con();
    },

    // 游戏库选择
    async getPagams(value) {
      if (value == "休闲") {
        const { data: res } = await this.$http.get(
          "/gz/gamebytag?tags=" +
            value +
            "&land=" +
            this.land +
            "&time=" +
            Date.now()
        );
        var len = res.length;
        var num = parseInt(len % 4);
        if (num == 1 || len == 1) {
          this.arder = res;
          this.arder.push({ isShow: true });
          this.arder.push({ isShow: true });
          this.arder.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.arder.push({ isShow: true });
            this.arder.push({ isShow: true });
            this.arder.push({ isShow: true });
            this.arder.push({ isShow: true });
          }
        } else if (num == 2 || len == 2) {
          this.arder = res;
          this.arder.push({ isShow: true });
          this.arder.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.arder.push({ isShow: true });
            this.arder.push({ isShow: true });
            this.arder.push({ isShow: true });
            this.arder.push({ isShow: true });
          }
        } else if (num == 3 || len == 3) {
          this.arder = res;
          this.arder.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.arder.push({ isShow: true });
            this.arder.push({ isShow: true });
            this.arder.push({ isShow: true });
            this.arder.push({ isShow: true });
          }
        } else if ((num == 0) & (document.body.offsetWidth > 500)) {
          this.arder = res;
          this.arder.push({ isShow: true });
          this.arder.push({ isShow: true });
          this.arder.push({ isShow: true });
          this.arder.push({ isShow: true });
          this.arder.push({ isShow: true });
          this.arder.push({ isShow: true });
        } else {
          this.arder = res;
        }
        // this.arder = res;
      } else if (value == "养成") {
        const { data: res } = await this.$http.get(
          "/gz/gamebytag?tags=" +
            value +
            "&land=" +
            this.land +
            "&time=" +
            Date.now()
        );
        var len = res.length;
        var num = parseInt(len % 4);
        if (num == 1 || len == 1) {
          this.cultivate = res;
          this.cultivate.push({ isShow: true });
          this.cultivate.push({ isShow: true });
          this.cultivate.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.cultivate.push({ isShow: true });
            this.cultivate.push({ isShow: true });
            this.cultivate.push({ isShow: true });
            this.cultivate.push({ isShow: true });
          }
        } else if (num == 2 || len == 2) {
          this.cultivate = res;
          this.cultivate.push({ isShow: true });
          this.cultivate.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.cultivate.push({ isShow: true });
            this.cultivate.push({ isShow: true });
            this.cultivate.push({ isShow: true });
            this.cultivate.push({ isShow: true });
          }
        } else if (num == 3 || len == 3) {
          this.cultivate = res;
          this.cultivate.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.cultivate.push({ isShow: true });
            this.cultivate.push({ isShow: true });
            this.cultivate.push({ isShow: true });
            this.cultivate.push({ isShow: true });
          }
        } else if ((num == 0) & (document.body.offsetWidth > 500)) {
          this.cultivate = res;
          this.cultivate.push({ isShow: true });
          this.cultivate.push({ isShow: true });
          this.cultivate.push({ isShow: true });
          this.cultivate.push({ isShow: true });
          this.cultivate.push({ isShow: true });
          this.cultivate.push({ isShow: true });
        } else {
          this.cultivate = res;
        }
        // this.cultivate = res;
      } else if (value == "经营") {
        const { data: res } = await this.$http.get(
          "/gz/gamebytag?tags=" +
            value +
            "&land=" +
            this.land +
            "&time=" +
            Date.now()
        );
        var len = res.length;
        var num = parseInt(len % 4);
        if (num == 1 || len == 1) {
          this.manage = res;
          this.manage.push({ isShow: true });
          this.manage.push({ isShow: true });
          this.manage.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.manage.push({ isShow: true });
            this.manage.push({ isShow: true });
            this.manage.push({ isShow: true });
            this.manage.push({ isShow: true });
          }
        } else if (num == 2 || len == 2) {
          this.manage = res;
          this.manage.push({ isShow: true });
          this.manage.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.manage.push({ isShow: true });
            this.manage.push({ isShow: true });
            this.manage.push({ isShow: true });
            this.manage.push({ isShow: true });
          }
        } else if (num == 3 || len == 3) {
          this.manage = res;
          this.manage.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.manage.push({ isShow: true });
            this.manage.push({ isShow: true });
            this.manage.push({ isShow: true });
            this.manage.push({ isShow: true });
          }
        } else if ((num == 0) & (document.body.offsetWidth > 500)) {
          this.manage = res;
          this.manage.push({ isShow: true });
          this.manage.push({ isShow: true });
          this.manage.push({ isShow: true });
          this.manage.push({ isShow: true });
          this.manage.push({ isShow: true });
          this.manage.push({ isShow: true });
        } else {
          this.manage = res;
        }
        // this.manage = res;
      } else if (value == "动作") {
        const { data: res } = await this.$http.get(
          "/gz/gamebytag?tags=" +
            value +
            "&land=" +
            this.land +
            "&time=" +
            Date.now()
        );
        var len = res.length;
        var num = parseInt(len % 4);
        if (num == 1 || len == 1) {
          this.movement = res;
          this.movement.push({ isShow: true });
          this.movement.push({ isShow: true });
          this.movement.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.movement.push({ isShow: true });
            this.movement.push({ isShow: true });
            this.movement.push({ isShow: true });
            this.movement.push({ isShow: true });
          }
        } else if (num == 2 || len == 2) {
          this.movement = res;
          this.movement.push({ isShow: true });
          this.movement.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.movement.push({ isShow: true });
            this.movement.push({ isShow: true });
            this.movement.push({ isShow: true });
            this.movement.push({ isShow: true });
          }
        } else if (num == 3 || len == 3) {
          this.movement = res;
          this.movement.push({ isShow: true });
          if (document.body.offsetWidth > 500) {
            this.movement.push({ isShow: true });
            this.movement.push({ isShow: true });
            this.movement.push({ isShow: true });
            this.movement.push({ isShow: true });
          }
        } else if ((num == 0) & (document.body.offsetWidth > 500)) {
          this.movement = res;
          this.movement.push({ isShow: true });
          this.movement.push({ isShow: true });
          this.movement.push({ isShow: true });
          this.movement.push({ isShow: true });
          this.movement.push({ isShow: true });
          this.movement.push({ isShow: true });
        } else {
          this.movement = res;
        }
        // this.movement = res;
      }
    },
    //匹配当前游戏
    mate(value) {
      this.all.map((item) => {
        if (item.id == value) {
          this.game_current = item.game_current;
          this.gameUrl = item.gameUrl;
          this.now = false;
          this.nows = true;
          if (item.gameUrl_last == null) {
            // this.gameUrl_last = item.gameUrl_last;
            this.now = false;
            this.nows = true;
            this.nowa = false;
          } else {
            this.gameUrl_last = item.gameUrl_last;
            this.now = false;
            this.nows = false;
            this.nowa = true;
          }
          if (item.game_last == null) {
            // this.game_last = item.game_last;
            this.now = false;
            this.nows = true;
            this.nowa = false;
          } else {
            this.game_last = item.game_last;
            this.now = false;
            this.nows = false;
            this.nowa = true;
          }

          // if (item.hasOwnProperty('gameUrl_last')) {
          //   this.gameUrl_last = item.gameUrl_last;
          //   this.now = false;
          //   this.nows = false;
          //   this.nowa = true;
          // }
          // if (item.hasOwnProperty('game_last')) {
          //   this.game_last = item.game_last;
          //   this.now = false;
          //   this.nows = false;
          //   this.nowa = true;
          // }
        }
      });
    },
    //提交Id到最近在玩
    async getId(value, href) {
      // this.wid();
      //最近在玩接口

      window.location.href = href;
      this.getPagam(value);
      this.dat = [];
      this.getMenuLists();

      // this.getPagam(value);
      // this.dat = [];
      // this.getMenuLists()
      // window.location.href = href;
    },
    async con() {
      // console.log('执行了');
      var tik_did = window.localStorage.getItem("tik_did");
      this.const.did = tik_did;
      this.const.time = Date.now();
      this.const.channel_id = this.game_id;
      // console.log(this.const,'this.const');
      const data = await this.$http
        .post("https://data.tikgamesite.com/api/report_gamebox", this.const)
        .then((res) => {
          // console.log(res,'res');
        });
    },
  },
};
</script>

<style lang="less" scoped>
@media screen and (orientation: landscape) {
  .bg_tab {
    height: 100vw !important;
    // width: 100vh !important;
  }
}

.bg_tab {
  height: 100vh;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(~@/assets/imgs/bg_home.png);
}

.title {
  text-align: center;
  // border: 1px solid red;
  padding: 45px 30px 5px 30px;
  margin-top: 20px;
  span {
    font-size: 20px;
    float: right;
    color: #000000;
    margin-top: -6px;
  }
}

.title_heat {
  padding: 0 10px;
  // border: 1px solid blue;
  height: 25px;
  display: flex;
  align-items: center;
}

.heat_img {
  width: 5px;
  height: 15px;
  // border:1px solid red;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-image: url(~@/assets/imgs/bg_title.png);
}

.heat_text {
  margin-left: 5px;
  // border: 1px solid red;
  line-height: 25px;
  font-weight: 600;
}

// 轮播图样式
.my-swipe {
  // border:1px solid red;
  width: 90%;
  // height:150px;
  // height: 100%;
  border-radius: 10px;
  padding: 0;
  // max-width:450PX;
  margin: 5px auto 5px auto;

  // width:20rem;
  // height:7.375rem;
}

.my-swipes {
  // border: 1px solid red;
  width: 90%;
  text-align: center;
  // height: 150px;
  border-radius: 10px;
  margin: 10px auto 10px auto;

  background-position: 0px 0px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.my-swipesa {
  // border:1px solid red;
  width: 90%;
  // height:150px;
  // height: 100%;
  border-radius: 10px;
  padding: 0;
  // max-width:450PX;
  margin: 5px auto 5px auto;

  // width:20rem;
  // height:7.375rem;
}

/deep/.van-swipe__track {
  height: 100%;
}

.my-swipe .van-swipe-item {
  width: 100%;
  height: 100%;
  color: #fff;
  font-size: 20px;
  // line-height: 150px;
  text-align: center;
  // background-color: #39a9ed;
}

.play {
  // padding:0 15px;
  max-height: 125px;
  display: flex;
  // justify-content: space-around;
  padding: 0 10px;
  border: 1px solid transparent;
}

.bg_play {
  width: 77px;
  height: 125px;
  margin: 0 10px;
  // border: 1px solid blue;
  background-position: 0px 10px;
  background-repeat: no-repeat;
  background-size: 100% 90%;
}

.play_img {
  // background: blue;
  // border: 1px solid red;
  border-radius: 10px;
  width: 50px;
  height: 50px;
  margin: 0 auto;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.play_title {
  margin-top: 10px;
  font-size: 10px;
  color: white;
  text-align: center;
}

.prevalent {
  // border:1px solid red;
  margin: 0 15px;
  height: 85px;
  display: flex;
  // overflow:scroll;
  // overflow-X:hidden;
  overflow: auto;
  // justify-content: space-around;
  justify-content: space-between;
  // margin:0 15px;
}

//游戏库
.prevalents {
  // border:1px solid red;
  text-align: center;
  margin: 0 15px;
  // height: calc(100vh - 600px);
  // height:ceil(1)*(10px);
  display: flex;
  // width: 300px;
  // overflow-Y:scroll;
  // overflow-X:hidden;
  overflow: auto;
  justify-content: space-around;
  // justify-content: space-between;
  // align-content: flex-start;
  // flex-direction:row;
  // justify-content: left;
  flex-wrap: wrap;
  // margin:0 15px;
  align-content: flex-start;
  // justify-content: space-between;
}

.prevalent_boxs {
  // border: 1px solid blue;
  width: 50px;
  // width: 25%;
  // width:3rem;
  height: 85px;
  // margin:0 17px;
  margin: 0 4.5%;
}

.prevalent_box {
  // border: 1px solid blue;
  width: 50px;
  // width: 25%;/
  // width:3rem;
  height: 100%;
  // margin:0 17px;
  margin: 0 5.6%;
}

.prevalent_img {
  // background: blue;
  border-radius: 10px;
  // border: 1px solid green;
  margin: 0 auto;
  width: 50px;
  height: 50px;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.prevalen_title {
  font-size: 10px;
  text-align: center;
  margin-top: 5px;
}

.prevalen_number {
  font-size: 7px;
  text-align: center;
  margin-top: 1px;
  color: #a9a9a9;
}

/deep/.van-tabs__wrap {
  height: 35px !important;
  // border: 1px solid blue;
}

/deep/.van-tabs__line {
  background-color: blue;
  width: 15px;
}

/deep/.van-tabs__nav {
  background-color: transparent;
  height: 17px;
  margin: 0;
  // border: 1px solid red;
}

/deep/.van-tab__text {
  font-size: 13px;
  font-weight: 600;
}

/deep/.van-tab--active {
  color: blue;
}

/deep/.van-tabs__line {
  bottom: 11px;
}

//隐藏滚动条
::-webkit-scrollbar {
  display: none;
}

.current {
  height: 100%;
  background-position: 0px 0px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
</style>
